/* eslint-disable no-restricted-imports */
import { useMemo } from 'react';
import { WishlistWishlistItem } from 'integration/generated/transactions/data-contracts';

export const useInWishList = (partNumber?: string, favoritesWishList?: WishlistWishlistItem) =>
	useMemo(() => {
		const found = favoritesWishList?.item?.find((item) => item.partNumber === partNumber);
		return !!found;
	}, [favoritesWishList, partNumber]);
